import React from 'react';

import cn from 'classnames';

import { Skeleton } from '@shared/ui';

import cls from './AddPaymentsSkeleton.module.css';

interface AddPaymentsSkeletonProps {
    classes?: string;
}

export const AddPaymentsSkeleton = ({ classes }: AddPaymentsSkeletonProps) => (
    <div className={cn(cls.AddPaymentsSkeleton, [classes])}>
        <Skeleton height={28} border="4px" />
        <Skeleton height={28} border="4px" />
        <Skeleton height={28} border="4px" />
        <Skeleton height={28} border="4px" />
        <Skeleton height={16} border="4px" />
        <Skeleton height={16} border="4px" />
    </div>
);
